export class Controller {

    /** @ngInject */
    constructor(
                $state,
                $uibModal,
                Account,
                Alert,
                CorporateSettingsService,
                DestructiveOperationModal,
                BarcodeGeneratonService,
                ) {
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Account = Account;
        this.Alert = Alert;
        this.CorporateSettingsService = CorporateSettingsService;
        this.DestructiveOperationModal = DestructiveOperationModal;
        this.BarcodeGeneratonService = BarcodeGeneratonService;
    }

    $onInit() {
        this.newSettings = angular.copy(this.settings);
        const companyId = this.companyId = this.$state.params.companyId;
        this.credentialsInitialized = false;
        this.credentials = {key: null, secret: null, ipFilter: null};
    }

    setIpFilterVar(){
        this.ipFilters = this.credentials && this.credentials.ipFilter ? this.credentials.ipFilter.split(";") : null;
    }

    clearNewSettings(){
        this.newSettings = angular.copy(this.settings);
    }

    getCredentials(){
        if (this.settings.hasCredentials) {
            const url = `app/rest/company/${this.companyId}/getCredentials`;
            this.DestructiveOperationModal({
                titleKey: 'corporate.destructive_op.get_credentials.title',
                textKey: 'corporate.destructive_op.get_credentials.text',
                http: {method: 'GET', url}
            }).then((data) => {
                this.getCredentialsCallback(data);
            });
        }
    }

    getCredentialsCallback(data){
        this.credentials = data;
        this.setIpFilterVar();
        this.credentialsInitialized = true;
        this.settings.hasCredentials = true;
        this.clearNewSettings();
    }

    setIpFilterAndOrGenerateCredentialsDestructiveCallback(data) {
        this.credentials = data;
        this.setIpFilterVar();
        this.credentialsInitialized = true;
        this.settings.hasCredentials = true;
        this.clearNewSettings();
        this.Alert('success', 'corporate.message.credentials_updated');
    }

    editCorporateProfile() {
        this.$uibModal
            .open({
                component: 'editCorporateProfile',
                resolve: {settings: () => this.settings},
            }).result
            .then((settings) => this.save(settings));
    }

    editRecoverySettings() {
        this.CorporateSettingsService
            .save(this.companyId, this.settings)
            .then((settings) => {
                    this.settings = settings;
                    this.newSettings = angular.copy(this.settings);
                    this.Alert('success', 'corporate.message.updated');
                }
            );
    }

    editIpAddressFilter() {
        this.$uibModal
            .open({
                component: 'editCorporateIpAddressFilter',
                resolve: {credentials: () => this.credentials},
            }).result
            .then((credentials) => {
                this.setIpFilterAndOrGenerateCredentialsDestructiveCallback(credentials);
            });
    }

    generateCredentials() {
        this.$uibModal
            .open({component: 'generateCorporateCredentials'}).result
            .then(() => this.DestructiveOperationModal({
                titleKey: 'corporate.destructive_op.generate_credentials.title',
                textKey: 'corporate.destructive_op.generate_credentials.text',
                http: {
                    method: 'GET',
                    url: `app/rest/company/${this.companyId}/generateCredentials`,
                }
            }))
            .then((credentials) => {
                this.setIpFilterAndOrGenerateCredentialsDestructiveCallback(credentials);
            });
    }


    loadQrData() {
        const url = `app/rest/company/${this.companyId}/generateOnpremActivationBarcode`;
        return this.DestructiveOperationModal({
            titleKey: 'corporate.destructive_op.generate_onprem_activation_barcode.title',
            textKey: 'corporate.destructive_op.generate_onprem_activation_barcode.text',
            http: {method: 'GET', url}
        }).then((data) => data.barcodeimage);
    }

    generateOnpremBarcode() {
        this.showBarcode = true;
    }

    hideOnpremBarcode() {
        this.showBarcode = false;
    }

    save(settings) {
        const numbers = [settings.phoneNumber, settings.phoneNumber2].filter((v) => v);
        [settings.phoneNumber, settings.phoneNumber2] = [...new Set(numbers)];

        this.CorporateSettingsService
            .save(this.companyId, settings)
            .then(() => {
                this.settings = settings;
                this.Alert('success', 'corporate.message.updated');
                this.Account.reload();
            })
    }
}


// WEBPACK FOOTER //
// ./src/portal/states/company/corporate-settings/company-profile/company-profile.controller.js